module.exports = __webpack_public_path__ + "static/media/ib_logo_osc.a01a1e19.svg";